module.exports = __webpack_public_path__ + "static/media/tirutsava_logo.86da7870.png";